import mobile from './mobile';

export default mobile;
